<template>
  <div v-show="isSelected()" class="drawer-list">
    <div
      class="drawer-inner container"
      @mouseover="setMouseOver"
      @mouseleave="unsetMouseOver"
    >
      <div v-if="src" class="row">
        <div class="title col-3">
          <router-link class="link" :to="{ name: to }">
            <img :src="title_img" class="icon" /><br />
            <span class="text"><slot name="title"></slot></span>
            <span class="top">トップ</span>
          </router-link>
        </div>
        <ul class="drawer-ul with-img col-9">
          <slot></slot>
        </ul>
      </div>
      <ul v-else class="drawer-ul no-img">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "DrawerList",
  props: {
    navName: { type: String, default: "" },
    src: { type: String, default: "" },
    title: { type: String, default: "" },
    to: { type: String, default: "" },
  },
  computed: {
    title_img() {
      return require("@/assets/images/header/" + this.src);
    },
  },
  methods: {
    isSelected: function () {
      return this.navName && this.$parent.onMouse === this.navName;
    },
    setMouseOver: function () {
      this.$parent.onMouse = this.navName;
    },
    unsetMouseOver: function () {
      this.$parent.onMouse = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.drawer-list {
  z-index: 999;
  width: 100%;
  left: 0;
  top: 108px;
  position: absolute;
  > .drawer-inner {
    max-width: 1200px;
    padding: 20px;
    margin: 0 auto;
    overflow-x: hidden;
    border: 1px solid $secondary;
    border-radius: 10px;
    box-shadow: 0px 3px 0px rgba(245, 245, 245, 0.8);
    background-color: $white;
    .drawer-ul {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
    }
    .title {
      margin-top: 20px;
      text-align: center;
      > .link {
        color: $primary;
        font-weight: bold;
        font-size: 20px;
        > .icon {
          width: 40px;
          height: auto;
          margin-bottom: 10px;
        }
        > .text {
          display: block;
          margin-bottom: 5px;
        }
        > .top {
          font-size: 14px;
          display: inline-block;
          width: 80px;
          background-image: url("@/assets/images/icons/arrow-right-orange.svg");
          background-size: 8px auto;
          background-position: right center;
          background-repeat: no-repeat;
        }
      }
    }
  }
  &:nth-last-of-type(1) {
    > .drawer-inner {
      border-top-right-radius: 0;
    }
  }
  &.-grid-2 .drawer-ul.no-img {
    width: 730px;
  }
  &.-grid-3 .drawer-ul {
    max-width: 1050px;
  }
  &.-grid-2 .drawer-ul.with-img {
    margin-bottom: 20px;
  }
  &.-grid-3 .drawer-ul {
    max-width: 1050px;
  }
}
</style>
